import { Quote } from "lucide-react";
import { Reveal, Eyebrow, MaskLine } from "./Primitives";

const STATS = [
  ["3", "Modalidades de treino"],
  ["1:1", "Atenção individual"],
  ["100%", "Treino personalizado"],
  ["On+Off", "Presencial e online"],
];

const TESTIMONIALS = [
  { n: 1, name: "Maíra Belfort", goal: "Personal presencial · Hipertrofia", quote: "Com o Carlos eu finalmente entendi como treinar de verdade. Cada treino é pensado para mim, com atenção total na execução. Ganhei força, confiança e uma rotina que eu amo." },
  { n: 2, name: "Juliana M.", goal: "Consultoria online · Emagrecimento", quote: "Mesmo à distância eu me sinto acompanhada todos os dias. O treino cabe na minha rotina e os ajustes chegam na hora certa. Os resultados vieram rápido." },
  { n: 3, name: "Rafael S.", goal: "Consultoria mista · Condicionamento", quote: "O formato misto foi perfeito pra mim: aulas presenciais para corrigir a técnica e o online para manter a constância. Nunca estive tão disposto." },
];

export const Results = () => (
  <section id="resultados" className="relative px-5 py-24 md:px-10 md:py-32" data-testid="results-section">
    <div className="mx-auto max-w-[1400px]">
      <Eyebrow index="04">Resultados</Eyebrow>
      <h2 className="mt-8 font-display text-5xl font-900 uppercase leading-[0.9] sm:text-6xl lg:text-8xl">
        <MaskLine inView>Quem treina</MaskLine>
        <MaskLine inView delay={0.1}><span className="text-[var(--red)]">sente.</span></MaskLine>
      </h2>

      <div className="mt-16 grid grid-cols-2 gap-px border border-white/10 bg-white/10 lg:grid-cols-4">
        {STATS.map(([v, l], i) => (
          <Reveal key={l} delay={i * 0.08} className="bg-[var(--ink)] p-6 md:p-10">
            <div className="font-display text-5xl font-900 leading-none sm:text-6xl md:text-8xl" data-testid={`results-stat-${i}`}>{v}</div>
            <div className="mt-3 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">{l}</div>
          </Reveal>
        ))}
      </div>

      <div className="mt-6 grid gap-4 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.n} delay={i * 0.1}>
            <figure className="flex h-full flex-col justify-between border border-white/10 bg-[var(--ink-3)] p-7 transition-colors duration-500 hover:border-[var(--red)]/60" data-testid={`testimonial-card-${t.n}`}>
              <Quote className="h-8 w-8 text-[var(--red)]" />
              <blockquote className="mt-6 text-lg leading-relaxed text-zinc-200">{t.quote}</blockquote>
              <figcaption className="mt-8 border-t border-white/10 pt-5">
                <div className="font-display text-xl font-800 uppercase">{t.name}</div>
                <div className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-400">{t.goal}</div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
